import type { ValueGetterParams } from "ag-grid-community";
import { monthCodeFromOffset, monthCodeToShortMonth, type MonthCode, type TData } from "@package/grid-utils";

export const cycleLabels = ["SWAP FP", "SWAP DIFF", "RATES", "SWAP vs RATES", "SWAP TS", "RATES TS"] as const;

/**
 * Each contract month occupies one block of rows in the Cycles layout, one row per
 * calculation listed in `cycleLabels`.
 */
export const cyclesRowsPerPeriod = cycleLabels.length;

export function cyclesValueGetter(params: ValueGetterParams<TData, string>) {
  if (params.data?.rowType !== "mth") {
    return undefined;
  }
  const rowIdx = params.node?.rowIndex ?? 0;
  return cycleLabels[rowIdx % cyclesRowsPerPeriod];
}

/**
 * Labels each Cycles block with its contract month (M0 at the top of the grid, then
 * M1, M2 …), leaving the remaining rows of the block blank.
 */
export function cyclesPeriodsValueGetter(params: ValueGetterParams<TData, string>) {
  if (params.data?.rowType !== "mth") {
    return undefined;
  }
  const rowIdx = params.node?.rowIndex ?? 0;
  if (rowIdx % cyclesRowsPerPeriod !== 0) {
    return undefined;
  }
  const monthCode = monthCodeFromOffset(rowIdx / cyclesRowsPerPeriod) as MonthCode.MonthCodeYY | undefined;
  return monthCode ? monthCodeToShortMonth(monthCode) : undefined;
}
